import { useEffect, useState } from 'react';
import type { ReactNode } from 'react';

function Panel({ onClose, children }: { onClose: () => void; children: ReactNode }) {
  return (
    <div
      className="fixed inset-0 z-[95] bg-[oklch(24%_0.02_50_/_0.35)] flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="w-[340px] max-w-[92vw] bg-card rounded-[10px] shadow-[0_12px_40px_oklch(24%_0.02_50_/_0.25)] px-6.5 pt-6.5 pb-5 z-[96]"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}

export default function AddItemModal({
  statusLabel,
  onAdd,
  onClose,
}: {
  statusLabel: string;
  onAdd: (title: string) => void;
  onClose: () => void;
}) {
  const [title, setTitle] = useState('');

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  const save = () => {
    const t = title.trim();
    if (!t) return;
    onAdd(t);
    onClose();
  };

  return (
    <Panel onClose={onClose}>
      <div className="font-serif italic text-[19px] mb-3.5">Add new item</div>
      <div className="text-xs text-muted mb-2">Column: {statusLabel}</div>
      <input
        autoFocus
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && save()}
        placeholder="Item name (e.g. Photographer)"
        className="w-full border border-line bg-cream px-2.5 py-2 text-sm outline-none focus:border-terra"
      />
      <div className="flex justify-end gap-2 mt-4.5">
        <button onClick={onClose} className="rounded-lg border border-line px-4 py-2 text-[13px]">
          Cancel
        </button>
        <button
          onClick={save}
          disabled={!title.trim()}
          className="rounded-lg bg-terra text-cream px-4 py-2 text-[13px] disabled:opacity-40"
        >
          Add
        </button>
      </div>
    </Panel>
  );
}
